module.exports = __webpack_public_path__ + "1a73b48e772215cc73b60d7322dbcbec.pdf";